

import PanelMapaVistaServicios from "./PanelMapaVistaServicios";
import PanelMapaVistaUnidad from "./PanelMapaVistaUnidad";

const PanelMapa = ({
    setDataUnidad,
    dataUnidad,
    setRutas,
    setListaRutasPanelIzquierdo,
    listaRutasPanelIzquierdo,
    setContadorPorMinuto,
    contadorPorMinuto,
    centrarUnidad,
    setUnidades,
    unidades,
    zona,
    setZona,
    cliente,
    setCliente,
    setConfirmadoNoConfirmado,
    confirmadoNoConfirmado,
    activeIndex,
    setUnidadSeleccionada,
    unidadSeleccionada,
    setCoordenadasVistaUnidades,
    coordenadasVistaUnidades,
    listaRutasPanelIzquierdoUnidad,
    setListaRutasPanelIzquierdoUnidad,

    setDataUnidadVistaUnidad,
    dataUnidadVistaUnidad,
    unidadCoordenadas,
    setUnidadCoordenadas,
    servicios,
    tipoServicio,
    setTipoServicio

}) => {


    return (

        <>
            {
                activeIndex == 0 ?
                    <PanelMapaVistaServicios
                        setDataUnidad={setDataUnidad}
                        dataUnidad={dataUnidad}
                        setRutas={setRutas}
                        listaRutasPanelIzquierdo={listaRutasPanelIzquierdo}
                        setContadorPorMinuto={setContadorPorMinuto}
                        contadorPorMinuto={contadorPorMinuto}
                        centrarUnidad={centrarUnidad}
                        setUnidades={setUnidades}
                        unidades={unidades}
                        zona={zona}
                        setZona={setZona}
                        setCliente={setCliente}
                        cliente={cliente}
                        tipoServicio={tipoServicio}
                        setTipoServicio={setTipoServicio}
                        activeIndex={activeIndex}
                        setUnidadSeleccionada={setUnidadSeleccionada}
                        unidadSeleccionada={unidadSeleccionada}
                        servicios={servicios}
                        setConfirmadoNoConfirmado={setConfirmadoNoConfirmado}
                        confirmadoNoConfirmado={confirmadoNoConfirmado}
                    ></PanelMapaVistaServicios> :
                    <PanelMapaVistaUnidad
                        setDataUnidad={setDataUnidad}
                        unidadSeleccionada={unidadSeleccionada}
                        dataUnidad={dataUnidad}
                        setUnidadCoordenadas={setUnidadCoordenadas}
                        unidadCoordenadas={unidadCoordenadas}
                        setRutas={setRutas}
                        listaRutasPanelIzquierdo={listaRutasPanelIzquierdo}
                        setContadorPorMinuto={setContadorPorMinuto}
                        contadorPorMinuto={contadorPorMinuto}
                        centrarUnidad={centrarUnidad}
                        setUnidades={setUnidades}
                        unidades={unidades}
                        zona={zona}
                        setZona={setZona}
                        activeIndex={activeIndex}
                        setUnidadSeleccionada={setUnidadSeleccionada}
                        

                        listaRutasPanelIzquierdoUnidad={listaRutasPanelIzquierdoUnidad}
                        setListaRutasPanelIzquierdoUnidad={setListaRutasPanelIzquierdoUnidad}



                        setCoordenadasVistaUnidades={setCoordenadasVistaUnidades}
                        coordenadasVistaUnidades={coordenadasVistaUnidades}
                        setDataUnidadVistaUnidad={setDataUnidadVistaUnidad}
                        dataUnidadVistaUnidad={dataUnidadVistaUnidad}
                    ></PanelMapaVistaUnidad>
            }
        </>
    );
};

export default PanelMapa;
